import React from "react";

import AmiB2CLogoMobile from "@components/shared/Icons/AmiB2CLogoMobile";
import AmiB2CLogoDesktop from "@components/shared/Icons/AmiB2CLogoDesktop";
import AmiB2BLogoMobile from "@components/shared/Icons/AmiB2BLogoMobile";
import AmiB2BLogoDesktop from "@components/shared/Icons/AmiB2BLogoDesktop";

import { useIsB2BSelected } from "@hooks/useIsB2BSelected";

const Logo = () => {
  const isB2BSelected = useIsB2BSelected();

  return (
    <div className="cursor-pointer w-16 smallMobile:w-24 sm:w-52 sm:relative [&_svg]:w-full">
      <div className="flex sm:hidden">
        {isB2BSelected ? (
          <AmiB2BLogoMobile size="lg" />
        ) : (
          <AmiB2CLogoMobile size="lg" />
        )}
      </div>
      <div className="hidden sm:flex">
        {isB2BSelected ? (
          <AmiB2BLogoDesktop size="lg" />
        ) : (
          <AmiB2CLogoDesktop size="lg" />
        )}
      </div>
    </div>
  );
};

export default Logo;
